<template>
  <RCard class="history">
    <AgGrid :options="gridOptions" :row-data="activities">
      <template #header>
        <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm q-mb-xs">History</div>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import { createdAtSorter } from '@lib/generic.utils'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  props: {
    activities: Array
  },

  computed: {
    gridOptions() {
      return {
        context: {
          sortColumn: 2
        },
        columnDefs: [
          {
            headerName: 'Description',
            field: 'description',
            tooltipField: 'description'
          },
          {
            headerName: 'User',
            field: 'causer.name',
            maxWidth: 200,
            tooltipField: 'causer.name'
          },
          {
            headerName: 'Date',
            field: 'created_at',
            comparator: createdAtSorter,
            maxWidth: 200,
            cellRenderer: params => this.formatDateTimeForLocale(params.value),
            tooltipValueGetter: params => this.formatDateTimeForLocale(params.value),
            sort: 'asc',
            type: 'centerAligned'
          }
        ],
        defaultColDef: {
          resizable: false,
          floatingFilter: false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.history {
  height: 485px;

  @include table-with-no-filters;
}
</style>
